import { apiRequest } from '../client'

export interface PublishBundleResponse {
  ok: boolean
  version: number
  timestamp: string
}

export const bundlesApi = {
  /**
   * Publish a new bundle version for a restaurant
   */
  publish: (restaurantId: number): Promise<PublishBundleResponse> =>
    apiRequest<PublishBundleResponse>('/api/v0/admin/bundles/publish', {
      method: 'POST',
      body: JSON.stringify({ restaurantId }),
    }),
}
